import React from "react"
import Swiper from "swiper"

import "./carousel.css"

import bannerDNA from "../images/home/banner-dna.png"

class Carousel extends React.Component {
  componentDidMount() {
    const { images } = this.props;
    const isProductCarousel = !!images;
    
    // Get the container element using ref instead of class selector
    const containerElement = this.swiperContainer;
    
    const swiperConfig = {
      // Optional parameters
      loop: !isProductCarousel,
      autoplay: !isProductCarousel,
      slidesPerView: isProductCarousel ? 'auto' : 1,
      slidesPerGroup: isProductCarousel ? 1 : 1,
      spaceBetween: isProductCarousel ? 40 : 0,
      centeredSlides: false,
      slideToClickedSlide: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      // Fix to ensure all slides are accessible
      initialSlide: 0,
      observer: true,
      observeParents: true,
      setWrapperSize: true,

      // Navigation arrows - use direct elements instead of selectors
      navigation: {
        nextEl: containerElement.querySelector(".swiper-button-next"),
        prevEl: containerElement.querySelector(".swiper-button-prev"),
      },
      
      // Events
      on: {
        slideChange: () => {
          if (isProductCarousel) {
            const { onImageClick } = this.props;
            if (onImageClick) {
              onImageClick(this.swiper.activeIndex);
            }
          }
        }
      }
    };
    
    // Add pagination only for banner carousel
    if (!isProductCarousel) {
      swiperConfig.pagination = {
        el: containerElement.querySelector(".swiper-pagination"),
      };
    }
    
    this.swiper = new Swiper(containerElement, swiperConfig)
  }

  componentWillUnmount() {
    this.swiper.destroy()
  }

  componentDidUpdate(prevProps) {
    const { activeIndex, images } = this.props;
    const isProductCarousel = !!images;
    
    // If this is a product carousel and activeIndex has changed, slide to the new index
    if (isProductCarousel && prevProps.activeIndex !== activeIndex) {
      this.swiper.slideTo(activeIndex);
    }
  }

  render() {
    const { images, onImageClick, activeIndex } = this.props;
    const isProductCarousel = !!images;
    
    // Default banner images for home page
    const bannerImages = [
      { imgSrc: bannerDNA, title: "DNA大数据的开拓者" }
    ];
    
    const displayImages = images || bannerImages;
    
    const containerClassName = isProductCarousel ? "swiper-container product-carousel" : "swiper-container";
    
    return (
      <div ref={el => this.swiperContainer = el} className={containerClassName}>
        <div className="swiper-wrapper">
          {displayImages.map((image, index) => {
            if (isProductCarousel) {
              // Product carousel mode
              const className = activeIndex === index ? 'swiper-slide productItem productActive' : 'swiper-slide productItem';
              return (
                <div 
                  key={index} 
                  className={className}
                  onClick={() => onImageClick(index)}
                >
                  <img 
                    src={image.imgSrc} 
                    alt={image.title} 
                    className="productImg"
                  />
                </div>
              );
            } else {
              // Banner carousel mode
              return (
                <div key={index} className="swiper-slide">
                  <img src={image.imgSrc} alt={image.title} />
                </div>
              );
            }
          })}
        </div>
        
        {/* Pagination only for banner carousel */}
        {!isProductCarousel && <div className="swiper-pagination"></div>}

        <div className="swiper-button-prev"></div>
        <div className="swiper-button-next"></div>
      </div>
    )
  }
}

export default Carousel
